import { CloseCircleOutlined } from '@ant-design/icons';
import styles from './WorkOrderFilter.module.scss';

const CLOSE_ICON = <CloseCircleOutlined aria-hidden />;

interface FilterAppliedPromptProps {
  onCancelFilter: () => void;
  onAdjustFilter: () => void;
  onClose: () => void;
}

const FilterAppliedPrompt = ({ onCancelFilter, onAdjustFilter, onClose }: FilterAppliedPromptProps) => (
  <div className={styles.filterPrompt}>
    <button type="button" className={styles.filterPromptClose} aria-label="Close" onClick={onClose}>
      {CLOSE_ICON}
    </button>
    <p className={styles.filterPromptText}>Would you like to cancel or adjust your filter?</p>
    <div className={styles.filterPromptActions}>
      <button type="button" className={styles.filterPromptAction} onClick={onCancelFilter}>
        Cancel Filter
      </button>
      <button type="button" className={styles.filterPromptAction} onClick={onAdjustFilter}>
        Adjust Filter
      </button>
    </div>
  </div>
);

export default FilterAppliedPrompt;
